import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Check, Gift, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function SanctuaryMembership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [];
  return <section data-section-id="39524" id="monthly-glow-club" ref={ref} className={cn("dark bg-[#332f2c] text-[#f8f7f6] py-24 lg:py-32 overflow-hidden relative", "transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_#a6966d_0%,_transparent_30%)] opacity-10 pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="space-y-10">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight text-[#e8e4e1] tracking-wide">Want to treat someone special to a glow up.. Get your gift your vouchers</h2>
              <p className="text-lg md:text-xl text-[#f8f7f6]/70 max-w-xl leading-relaxed font-sans">Collect from the Salon or we can email to you.</p>
            </div>

            <ul className="space-y-5">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-4 group">
                  <div className="mt-1 p-1 rounded-lg bg-[#a6966d]/10 group-hover:bg-[#a6966d]/20 transition-colors duration-300">
                    <Check className="w-5 h-5 text-[#a6966d] shrink-0" />
                  </div>
                  
                </li>)}
            </ul>

            <div className="pt-4">
              <Button asChild size="lg" className="bg-[#a6966d] text-white hover:bg-[#a6966d]/90 h-14 px-8 text-sm uppercase tracking-widest rounded-lg shadow-lg shadow-black/20 transition-all hover:shadow-black/30 hover:-translate-y-0.5">
                <Link to="tel:07766733976">PURCHASE YOUr GIFT VOUCHER</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative flex justify-center lg:justify-end mt-8 lg:mt-0">
            {}
            <div className="absolute inset-0 bg-[#a6966d]/10 blur-[80px] rounded-lg transform scale-90 pointer-events-none" />

            <div className="relative w-full max-w-md [perspective:1000px]">
                {}
                <Card className="relative overflow-hidden border border-[#a6966d]/30 bg-[#332f2c] text-[#f8f7f6] shadow-2xl rounded-3xl aspect-[1.58/1] transform transition-transform duration-700 hover:scale-[1.02] hover:rotate-1 group">
                    {}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#332f2c] via-[#3a3532] to-[#a6966d]/10 opacity-80" />
                    <div className="absolute -right-12 -top-12 w-48 h-48 bg-[#a6966d]/10 rounded-lg blur-3xl group-hover:bg-[#a6966d]/15 transition-colors duration-700" />
                    <div className="absolute -left-12 -bottom-12 w-48 h-48 bg-[#e8e4e1]/5 rounded-lg blur-3xl group-hover:bg-[#e8e4e1]/10 transition-colors duration-700" />
                    
                    {}
                    <div className="absolute inset-0 opacity-10 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/cubes.png')] mix-blend-overlay" />

                    <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-10">
                        <div className="flex justify-between items-start">
                            <div className="space-y-1">
                                <span className="block font-serif text-2xl italic tracking-wide text-[#e8e4e1]">Natalia's Beauty</span>
                                <span className="block text-[10px] uppercase tracking-[0.2em] text-[#a6966d] opacity-80">Exclusive Invitation</span>
                            </div>
                            <Gift className="w-8 h-8 text-[#a6966d] opacity-90" />
                        </div>

                        <div className="space-y-2">
                            <h3 className="text-3xl md:text-4xl font-serif text-[#f8f7f6] tracking-tight">Gift Radiance</h3>
                            <p className="text-sm text-[#a6966d] font-medium tracking-widest uppercase">The Art of Elegance</p>
                        </div>
                    </div>
                </Card>

                {}
                <div className="absolute -bottom-8 -left-4 md:-left-10 bg-[#f8f7f6]/95 backdrop-blur-md p-5 rounded-3xl shadow-xl border border-[#a6966d]/20 max-w-[260px] animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300 fill-mode-backwards">
                    <div className="flex items-start gap-3 mb-4">
                        <div className="p-2.5 bg-[#a6966d]/10 rounded-lg text-[#a6966d] shrink-0">
                            <Sparkles className="w-4 h-4" />
                        </div>
                        <div>
                            <p className="font-medium text-[#332f2c] text-sm font-sans">Share the Glow</p>
                            <p className="text-xs text-[#332f2c]/70 mt-0.5 leading-snug font-sans">
                                Perfect for birthdays, anniversaries, or just because.
                            </p>
                        </div>
                    </div>
                    <Button asChild variant="outline" size="sm" className="w-full border-[#a6966d]/30 text-[#332f2c] hover:bg-[#a6966d]/5 hover:text-[#a6966d] hover:border-[#a6966d]/50 transition-colors rounded-lg text-[10px] uppercase tracking-widest">
                        <Link to="#">Purchase Gift Card</Link>
                    </Button>
                </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}